<list-view *ngIf="listeCompagnies" [liste]="listeCompagnies"></list-view>